import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

const Button = (props) => {
  const { children, onClick, className, role, type, disabled } = props;
  return (
    <button
      className={className}
      onClick={onClick}
      role={role}
      disabled={disabled}
      type={type}
    >
      {children}
    </button>
  );
};

export default Button;

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  role: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  className: 'button',
  role: 'button',
  type: 'button',
  children: null,
  disabled: false,
  onClick: noop,
};
